import { render, staticRenderFns } from "./relmalllist.vue?vue&type=template&id=2e6299fd&scoped=true"
import script from "./relmalllist.vue?vue&type=script&lang=js"
export * from "./relmalllist.vue?vue&type=script&lang=js"
import style0 from "./relmalllist.vue?vue&type=style&index=0&id=2e6299fd&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e6299fd",
  null
  
)

export default component.exports